import React, { ReactElement } from 'react'
import { Flex, ThemeUIStyleObject } from 'theme-ui'
import CarouselCard from 'components/Organization/HomePage/Sections/WhatPeopleSay/CarouselCard'
import { testimonialData } from 'components/Organization/HomePage/Sections/Testimonials/testimonialData'

const testimonialCount = testimonialData.length

export function CarouselTrack({ sx }: { sx?: ThemeUIStyleObject }): ReactElement {
  return (
    <Flex
      sx={{
        height: '32rem',
        position: 'relative',
        flexShrink: 0,
        animation: `300s slide infinite linear`,
        width: `auto`,
        ...sx,
      }}
    >
      {testimonialData.map((testimonial, index) => (
        <CarouselCard key={index} name={testimonial.name} testimonial={testimonial.testimonial} />
      ))}
    </Flex>
  )
}

export default function TestimonialCarousel(): ReactElement {
  return (
    <Flex
      data-testid="testimonial-carousel"
      className="ios-scrolling-glitches-fix"
      sx={{
        contentVisibility: 'auto',
        overflow: 'hidden',
        height: '100%',
        width: '100vw',
        position: 'relative',
        ':hover > div': {
          animationPlayState: 'paused',
        },
        '::before, ::after': {
          content: '""',
          position: 'absolute',
          zIndex: 'zIndex1',
          top: 0,
          bottom: 0,
          width: '15rem',
        },
        '::before': {
          left: 0,
          background: [
            'none',
            `linear-gradient(to left, transparent, rgba(1, 8, 24, 1) 100%, rgba(1, 8, 24, 0.3) 70%, #010818)`,
          ],
        },
        '::after': {
          right: 0,
          background: [
            'none',
            `linear-gradient(to right, transparent, rgba(1, 8, 24, 1) 100%, rgba(1, 8, 24, 0.3) 70%, #010818)`,
          ],
        },
        '@keyframes slide': {
          from: {
            transform: 'translateX(0)',
          },
          to: {
            transform: `translateX(-${39.2 * testimonialCount}rem)`,
          },
        },
      }}
    >
      {/* the solution can be improved by using a more precise number of elements, which is necessary to avoid flickering */}
      <CarouselTrack />
      {/* it is important for an infinite carousel that there is no flickering */}
      <CarouselTrack sx={{ display: ['none', 'flex'] }} />
    </Flex>
  )
}
